// Javascript for Cart Drawer

/*==================================================
 * functions 
==================================================*/

function updateCartItemCount(count) {
  document.querySelector("[data-cart-drawer-total-quantity]").textContent = count;
}

async function updateCartDrawer() {
  // fetch the updated cart-drawer.liquid section
  const res = await fetch(window.Shopify.routes.root + "?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const updatedCartHTML = html.querySelector("[data-cart-drawer-wrapper]").innerHTML;

  document.querySelector("[data-cart-drawer-wrapper]").innerHTML = updatedCartHTML;

  // re-add listeners as the fetching will remove all listeners
  addCartDrawerListeners();
}

function addCartDrawerListeners() {

  // reinit variables as fetch removes all variables
  const cartDrawerWrapper = document.querySelector("[data-cart-drawer-wrapper]")
  const cartDrawerCloseButton = document.querySelector("[data-cart-drawer-close-btn]");
  const cartDrawer = document.querySelector("[data-cart-drawer]");
  const quantityButtons = document.querySelectorAll("[data-cart-drawer-quantity-button]");

  quantityButtons.forEach((button) => {
    const quantityInput = button.closest("div")
                                .querySelector("input");
    const lineItemKey = button.closest("[data-line-item-key]").dataset.lineItemKey.toString();
    button.addEventListener('click', async (e) => {
      e.preventDefault();

      let newQuantity = Number(quantityInput.value);
      if (button.dataset.cartDrawerQuantityButton === "minus") {
        // minus button updates cart
        newQuantity = Math.max(0, newQuantity - 1);
      } else if (button.dataset.cartDrawerQuantityButton === "plus") {
        // plus button updates cart
        newQuantity += 1;
      }

      const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [lineItemKey]: newQuantity } }),
      });
      const cart = await res.json();
      updateCartItemCount(cart.item_count);

      await updateCartDrawer();
    })
  })

  // cross button close cart drawer
  if (cartDrawerCloseButton) {
    cartDrawerCloseButton.addEventListener("click", () => {
      const cartDrawerWrapper = cartDrawerCloseButton.closest("[data-cart-drawer-wrapper]");
      if (cartDrawerWrapper.dataset.cartDrawerWrapper === "open") {
        cartDrawerWrapper.dataset.cartDrawerWrapper = "close";
      }
    })
  }

  // enable click-and-close within cart drawer wrapper
  if (cartDrawerWrapper) {
    cartDrawerWrapper.addEventListener("click", () => {
      if (cartDrawerWrapper.dataset.cartDrawerWrapper === "open") {
        cartDrawerWrapper.dataset.cartDrawerWrapper = "close";
      }
    })
  }

  // disable click-and-close within cart drawer
  if (cartDrawer) {
    cartDrawer.addEventListener("click", (e) => {
      e.stopPropagation();
    })
  }
}

// add all the listeners when landing
addCartDrawerListeners();

// Add to cart
document.querySelectorAll('form').forEach((form) => {
  if (form.action.includes('/cart/add')) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      // submit form with ajax
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "post",
        body: new FormData(form),
      })

      // update cart before open
      await updateCartDrawer();

      // open cart drawer
      document.querySelector("[data-cart-drawer-wrapper]").dataset.cartDrawerWrapper = "open";
    })
  }
})
